import React, { useState, useEffect, useRef } from 'react';
import { useTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { LineChart, BarChart, CandlestickChart } from 'echarts/charts';
import {
    GridComponent,
    TooltipComponent,
    TitleComponent,
    TimelineComponent,
    MarkPointComponent,
    MarkLineComponent,
    MarkAreaComponent,
    LegendComponent,
    DataZoomComponent,
    DataZoomInsideComponent,
    DataZoomSliderComponent,
    VisualMapComponent,
    VisualMapContinuousComponent,
    VisualMapPiecewiseComponent,
} from 'echarts/components';
import {
    CanvasRenderer,
} from 'echarts/renderers';
import { Box, Typography } from '@mui/material';


echarts.use(
    [VisualMapComponent, VisualMapContinuousComponent, VisualMapPiecewiseComponent, TitleComponent, TooltipComponent, GridComponent, LineChart, CandlestickChart, CanvasRenderer, DataZoomComponent,
        DataZoomInsideComponent, DataZoomSliderComponent, MarkPointComponent, MarkLineComponent, TimelineComponent,
        LegendComponent, MarkAreaComponent, BarChart]
);


const useStyles = makeStyles(theme => ({
    table: {
        // minWidth: 650,
    },
    root1: {
        flexGrow: 1,
    },
    menuButton: {
        // marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
    grid: {
        // width: `calc(100% + ${6 + (theme.spacing(1))}px)`
    }
}));



export default function TranChart(props) {
    const classes = useStyles();
    const theme = useTheme();

    const [option, setOption] = React.useState(null);
    const [result, setResult] = React.useState(null);

    function genoption1() {
        let k = {
            animation: false,
            tooltip: {
                trigger: 'axis'
            },            
            grid: [{
                top: 30,
                left: 5,
                right: 5,
                // height: 100,
                bottom: 0,
                containLabel: true
            }],
            xAxis: [{
                type: 'category',
                boundaryGap: true,
                data: result.map(row => row.ymd),
            }],
            yAxis: [{
                name: "庫存",
                nameLocation:"end",
                scale: true,
                type: 'value',
                position: 'left',
                show: true,
                splitLine: {
                    show: true,
                    lineStyle: {
                        opacity: 0.2
                    }
                }
            },{
                name: "價格",
                nameLocation:"end",
                scale: false,
                type: 'value',
                position: 'right',
                show: true,
            }],
            series: [
                {
                    name: '庫存',
                    type: 'bar',
                    data: result.map(row => row.piece),
                    smooth: true,
                    showSymbol: false,
                    markLine: {
                        symbol: ['none', 'none'],
                        label: {
                            show: true,
                            formatter: "現在"
                        },
                        data: [
                            {
                                name: '現在',
                                yAxis: "820000"
                            }
                        ]
                    },

                    // markLine: {
                    //     data: [
                    //         {
                    //             name: 'Horizontal line with Y value at 100',
                    //             yAxis: 120000
                    //         },
                    //     ]
                    // }
                },
                {
                    name: '價格',
                    type: 'line',
                    data: result.map(row => row.price),
                    smooth: true,
                    showSymbol: false,
                    yAxisIndex: 1,

                    // markLine: {
                    //     data: [
                    //         {
                    //             name: 'Horizontal line with Y value at 100',
                    //             yAxis: 120000
                    //         },
                    //     ]
                    // }
                }
            ]
        };
        return k;
    }

    useEffect(() => {
        if(props.result != null) setResult(props.result.reverse())
        // if(props.prices != null) setOption(genoption1)
    }, [props.result]);

    useEffect(() => {
        if(result != null) setOption(genoption1)
        // if(props.prices != null) setOption(genoption1)
    }, [result]);

    const clickDetail = () => {
        if (props.setOpen != null) props.setOpen(true)
    }

    return (
        <Box sx={{ m:1.5 }} >
            
            {/* <Typography variant="h6">預估總股息
            </Typography>
            <Typography variant="caption">目標:50萬，實際：23.3萬，完成日：2033年</Typography>
             */}
            {option != null ?
                <ReactEChartsCore
                    theme={theme.palette.mode}
                    echarts={echarts}
                    option={option}
                    notMerge={true}
                    lazyUpdate={false}
                    style={{ height: 150 }}
                // onEvents={onEvents}
                />
                : null}
        </Box>
    );
}

